module.exports = __webpack_public_path__ + "img/teacher_women_40.5d5beea3.png";